import mapboxgl, { MapboxOptions } from 'mapbox-gl'

export const DefaultConfig: MapboxOptions = {
  container: 'map', // container ID
  style: 'mapbox://styles/mapbox/streets-v11', // style URL
  center: [8.224314275992242, 46.752865766404824], // starting position [lng, lat]
  zoom: 7.28, // starting zoom
  projection: { name: 'mercator' }, // display the map as a 3D globe
  attributionControl: false,
}
export const AccessToken =
  'pk.eyJ1IjoidGEtaW50ZXJha3RpdiIsImEiOiJjaXNhNGFsdHAwMDB2Mm9wNWdlMTlqMTNuIn0.uj5aGvF3yvEM4V6kNdlbVg'
mapboxgl.accessToken = AccessToken
